import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";
import { ShiftType } from "src/client/react/src/staffhub/sh-models";

export default mutatorAction("selectPanelType", function selectPanelType(selectedPanelType: ShiftType) {
    shiftEditorViewState().selectedPanelType = selectedPanelType;
});